import { mutation, query } from '@/services/graphql';
import * as operations from './operations';

export default {
  teacherLogin(variables = {}) {
    return mutation(operations.TEACHER_LOGIN, variables, true);
  },
  studentList(variables = {}, loading = true) {
    return query(operations.STUDENT_LIST, variables, loading);
  },
};
